import { OtherWallet } from './other-wallets.model';

/** The commodity wallets the «سایر» sheet lists, in the wallet pickers' order. */
export const OTHER_WALLETS: readonly OtherWallet[] = [
	{ key: 'Option', title: 'اختیار معامله کالا' },
	{ key: 'Future', title: 'آتی کالا' },
	{ key: 'WareHouse', title: 'هزینه انبارداری' }
];
